import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, Layers, FlaskConical, ClipboardCheck, Beaker, PlusCircle } from 'lucide-react';
const reasons = [{
  icon: <Clock data-id="element-291" />,
  title: 'Recupera tus horas de planificación',
  desc: 'No comiences desde cero. Solo abre, imprime y utiliza el material.'
}, {
  icon: <Layers data-id="element-292" />,
  title: 'Secuencia clara',
  desc: 'Cada contenido ya está ordenado según el nivel para que no improvises ni mezcles temas.'
}, {
  icon: <FlaskConical data-id="element-293" />,
  title: 'Química más visual y fácil de interpretar',
  desc: 'Explica átomos, enlaces, fórmulas, reacciones y cálculos mediante imágenes, esquemas, ejemplos y secuencias visuales.'
}, {
  icon: <ClipboardCheck data-id="element-294" />,
  title: 'Menos corrección, más claridad',
  desc: 'Las rúbricas y criterios integrados te ahorran horas y te ordenan la evaluación.'
}, {
  icon: <Beaker data-id="element-295" />,
  title: 'Historietas con contenido científico',
  desc: 'Incluye historias como Los chismes de la tabla y Los elementos infieles, con humor, reflexión y contenidos relacionados con las propiedades y el comportamiento de los elementos químicos.'
}, {
  icon: <PlusCircle data-id="element-296" />,
  title: 'Material flexible',
  desc: 'Recibes los documentos completos y también fichas individuales para imprimir, proyectar o compartir según las necesidades de cada clase.'
}];
export function WhyChoose() {
  return <section className="py-6 md:py-12 px-4 bg-blue-50/50" data-id="element-297">
      <div className="max-w-6xl mx-auto" data-id="element-298">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-299">
          ¿Por qué elegir el MEGAPACK?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-300">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl border border-blue-100 shadow-xl shadow-blue-900/5 flex flex-col items-center text-center group hover:border-blue-300 transition-colors" data-id="element-301">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 text-blue-600 group-hover:scale-110 transition-transform" data-id="element-302">
                {cloneElement(reason.icon as React.ReactElement, {
              size: 28
            })}
              </div>
              <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 leading-tight" data-id="element-303">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed" data-id="element-304">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}